import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import {
  HomeIcon,
  MagnifyingGlassIcon,
  PlusCircleIcon,
  HeartIcon,
  UserCircleIcon,
} from '@heroicons/react/24/outline';
import {
  HomeIcon as HomeIconSolid,
  HeartIcon as HeartIconSolid,
  UserCircleIcon as UserCircleIconSolid,
} from '@heroicons/react/24/solid';

const MobileNav: React.FC = () => {
  const location = useLocation();
  const { isAuthenticated } = useAuth();
  const currentPath = location.pathname;

  const navItems = [
    {
      path: '/',
      label: 'Home',
      icon: HomeIcon,
      activeIcon: HomeIconSolid,
    },
    {
      path: '/search',
      label: 'Search',
      icon: MagnifyingGlassIcon,
      activeIcon: MagnifyingGlassIcon,
    },
    {
      path: '/post-ad',
      label: 'Sell',
      icon: PlusCircleIcon,
      activeIcon: PlusCircleIcon,
      isCenter: true,
    },
    {
      path: '/favorites',
      label: 'Saved',
      icon: HeartIcon,
      activeIcon: HeartIconSolid,
    },
    {
      path: isAuthenticated ? '/dashboard' : '/login',
      label: 'Account',
      icon: UserCircleIcon,
      activeIcon: UserCircleIconSolid,
    },
  ];

  const isActive = (path: string) => {
    if (path === '/') return currentPath === '/';
    return currentPath.startsWith(path);
  };

  return (
    <nav className="mobile-nav d-md-none safe-area-bottom">
      <div className="d-flex justify-content-around align-items-center" style={{ height: '64px' }}>
        {navItems.map((item) => {
          const active = isActive(item.path);
          const Icon = active ? item.activeIcon : item.icon;

          if (item.isCenter) {
            // Sell Button - Orange Accent for maximum visibility
            return (
              <Link
                key={item.path}
                to={item.path}
                className="mobile-nav-sell text-decoration-none"
              >
                <div className="mobile-nav-sell-button">
                  <Icon style={{ width: '28px', height: '28px' }} />
                </div>
                <span className="position-absolute text-xs fw-bold text-warning" style={{ bottom: '-20px', left: '50%', transform: 'translateX(-50%)' }}>
                  {item.label}
                </span>
              </Link>
            );
          }

          return (
            <Link
              key={item.path}
              to={item.path}
              className={`mobile-nav-item text-decoration-none ${active ? 'active' : ''}`}
            >
              <Icon
                className={`mb-1 ${active ? 'text-primary' : 'text-secondary'}`}
                style={{ width: '24px', height: '24px' }}
              />
              <span className={active ? 'text-primary fw-medium' : 'text-secondary'}>
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileNav;
